import React, { useState } from 'react';
import { useFetch } from '../../hooks/useFetch';
import { useToast, Spinner, ErrorBanner, EmptyState, Modal } from '../../components/ui';
import { fmt, errMsg } from '../../utils/format';
import api from '../../utils/api';

export default function Adjustments() {
  const { data, loading, error, refetch } = useFetch('/api/adjustments?limit=100');
  const { showToast, Toast } = useToast();
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ entityType:'product', entityId:'', quantityDelta:'', reason:'' });
  const [saving, setSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      await api.post('/api/adjustments', { ...form, entityId: parseInt(form.entityId), quantityDelta: parseFloat(form.quantityDelta) });
      setModal(false); setForm({ entityType:'product', entityId:'', quantityDelta:'', reason:'' }); refetch(); showToast('Adjustment recorded successfully');
    } catch (err) { alert(errMsg(err)); }
    finally { setSaving(false); }
  };

  if (loading) return <Spinner />;
  if (error) return <ErrorBanner message={error} onRetry={refetch} />;
  return (
    <div>

      {modal && (
        <Modal title="New Adjustment" onClose={() => setModal(false)}
          footer={<><button className="btn" onClick={() => setModal(false)}>Cancel</button><button className="btn btn-primary" form="adj-form" type="submit">{saving?'Saving…':'Save'}</button></>}>
          <form id="adj-form" onSubmit={save}>
            <div className="form-group"><label>Type</label><select value={form.entityType} onChange={e => setForm(f=>({...f,entityType:e.target.value}))}><option value="product">Finished good</option><option value="raw_material">Raw material</option></select></div>
            <div className="form-group"><label>Record ID</label><input type="number" required value={form.entityId} onChange={e => setForm(f=>({...f,entityId:e.target.value}))} placeholder="Product or material ID" /></div>
            <div className="form-group"><label>Quantity delta (negative to reduce)</label><input type="number" step="0.0001" required value={form.quantityDelta} onChange={e => setForm(f=>({...f,quantityDelta:e.target.value}))} /></div>
            <div className="form-group"><label>Reason</label><input required value={form.reason} onChange={e => setForm(f=>({...f,reason:e.target.value}))} /></div>
          </form>
        </Modal>
      )}
      <div className="page-header"><h1>Inventory Adjustments</h1><div className="page-actions"><button className="btn btn-primary btn-sm" onClick={() => setModal(true)}><i className="ti ti-plus" /> New adjustment</button></div></div>
      <div className="card">
        <div className="table-wrap">
          <table>
            <thead><tr><th>Type</th><th>Entity ID</th><th>Delta</th><th>Reason</th><th>Source</th><th>By</th><th>Date</th></tr></thead>
            <tbody>
              {(data || []).map(a => (
                <tr key={a.id}>
                  <td style={{ fontSize:12 }}>{a.entity_type}</td>
                  <td style={{ fontFamily:'monospace', fontSize:12 }}>{a.entity_id}</td>
                  <td style={{ color: a.quantity_delta > 0 ? 'var(--green)' : 'var(--red)', fontWeight:500 }}>
                    {a.quantity_delta > 0 ? '+' : ''}{a.quantity_delta}
                  </td>
                  <td style={{ fontSize:12 }}>{a.reason}</td>
                  <td style={{ fontSize:12 }}>{a.source}</td>
                  <td style={{ fontSize:12 }}>{a.performed_by_name || 'System'}</td>
                  <td style={{ fontSize:12 }}>{fmt.dateTime(a.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {!(data||[]).length && <EmptyState icon="ti-adjustments" message="No adjustments recorded" />}
        </div>
      </div>
    </div>
  );
}
